import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { getListViews } from '../handler/ViewHandler';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export const DialogNoticeViewChanged = (props) => {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }

        props.setIsOpenDialogViewChanged(false);
    };

    const onClickOkButton = async () => {
        props.setIsLoading(true);
        props.setIsOpenDialogViewChanged(false);
        await getListViews(props, props.projectSelectedId, props.viewStructure.visibility, null, props.setIsScrollNewViews, true);
        props.setIsLoading(false);
    };

    return (
        <Dialog
            open={props.isOpenDialogViewChanged}
            onClose={(event, reason) => onCloseConfirm(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                    {tr('データが変更されました。ページを更新してください。')}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    className="btn-hg32 btn-handle-delete-user-agree"
                    variant="contained"
                    onClick={async () => await onClickOkButton()}
                >
                    {tr('はい')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
